// Dependency's modules
import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngSanitize from 'angular-sanitize';
import ngTouch from 'angular-touch';
import uiRouter from '@uirouter/angularjs';
import uiBootstrap from 'angular-ui-bootstrap';
import ocLazyLoad from 'oclazyload';
import loadingBar from 'angular-loading-bar';
import duScroll from 'angular-scroll';
import restangular from 'restangular';
import angularMoment from 'angular-moment';
import ngAside from 'angular-aside';
import toastr from 'angular-toastr';
import angularGoogleAnalytics from 'angular-google-analytics';
import uiSelect from 'ui-select';
import angular from 'angular';
// No commonjs support
import 'ngstorage';
import 'angular-breadcrumb';
import 'angular-xeditable';
import 'tc-angular-chartjs';

// Plugins
import 'angular-i18n/angular-locale_es-ar';
import 'moment/locale/es.js';
import 'bootstrap-sass/assets/javascripts/bootstrap/modal';
// import 'angular-ui-bootstrap/dist/ui-bootstrap-tpls';
import 'chart.js';

const moduleName = 'atc-vendor';
angular.module(moduleName, [
    ngAnimate,
    ngCookies,
    ngSanitize,
    ngTouch,
    uiRouter,
    uiBootstrap,
    ocLazyLoad,
    loadingBar,
    duScroll,
    angularMoment,
    restangular,
    ngAside,
    toastr,
    angularGoogleAnalytics,
    uiSelect,
    'ngStorage',
    'ncy-angular-breadcrumb',
    'xeditable',
    'tc.chartjs'
]);

export default moduleName;